export const parseResults = (results) => {
  return results.map(result => {
    const orderNumber = `${result.anio}-${result.mes}-${result.nro_orden}`
    const vigencia = `${result.fecha.split('T')[0].replace(/-/g, '/')} - ${result.FECHA_EXPIRACION.split('T')[0].replace(/-/g, '/')}`
    return {
      'N Órden': orderNumber,
      'Vigencia': vigencia,
      'Medios': result.medios.lenth > 0 ? result.medios.join(' - ') : result.medios[0],
      'Anunciante': result.Anunciante,
      'Producto': result.desc_producto,
    }
  })
};

export const getFileType = (file) => {
  const extension = file?.split('.').slice(-1)[0];
  switch (extension) {
    case 'jpg':
    case 'png':
    case 'jpeg':
    case 'bmp':
      return 'Imagen';
    case 'mp3':
    case 'wav':
      return 'Audio'
    case 'avi':
    case 'mov':
    case 'mp4':
      return 'Video'
    default:
      return extension;
  }
}

export const getFileTypeName = async (type) => {
  let fileTypeName;
  switch (type) {
    case 1:
      fileTypeName = 'Programados';
      break;
    case 2:
      fileTypeName = 'Transmitidos';
      break;
    case 3:
      fileTypeName = 'Testigos';
      break;
    default:
      fileTypeName = '';
      break;
  }
  return fileTypeName;
};

export const formatMoney = (value) => new Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'}).format(value);